import { SearchBar } from '@amelio/ui-library';

import { TABLE_SEARCH_WIDTH, TABLE_TOOLBAR_LAYOUT } from '../calibrationStyles';

import { useAmelioTranslations } from '@/hooks';

export interface TableToolbarProps {
    searchQuery: string;
    onSearchChange: (query: string) => void;
}

/** Name search above the employee calibration table, kept to the right so it stays a tool rather
 * than a heading. */
export const TableToolbar = ({ searchQuery, onSearchChange }: TableToolbarProps) => {
    const { t } = useAmelioTranslations();

    return (
        <div className={TABLE_TOOLBAR_LAYOUT}>
            <div className={TABLE_SEARCH_WIDTH}>
                <SearchBar
                    value={searchQuery}
                    onChange={onSearchChange}
                    placeholder={t('calibration.table.search')}
                    ariaLabel={t('calibration.table.search')}
                    showClearButton
                    onClear={() => onSearchChange('')}
                    dataTestId={'calibration-table-search'}
                />
            </div>
        </div>
    );
};
